import { DxDataGridComponent, DxDiagramComponent, DxListComponent, DxScrollViewComponent, DxSelectBoxComponent, DxTreeViewComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { IoConfigurationComponent } from '../io-configuration/io-configuration.component';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewContainerRef } from '@angular/core';
import { SystemComponentService } from 'src/app/services/system-component.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { EstimateService } from 'src/app/services/estimate.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import ArrayStore from 'devextreme/data/array_store';
import DataGrid from "devextreme/ui/data_grid";
import { ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from 'src/app/app-config.service.service';
import { UserService } from 'src/app/services/user.service';
import { LoadingService } from 'src/app/services/loading.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import * as introJs from 'intro.js/intro.js';

@Component({
  selector: 'import-from-library',
  templateUrl: './import-from-library.component.html',
  styleUrls: ['./import-from-library.component.scss']
})
export class ImportFromLibraryComponent implements OnInit {

  @ViewChild("contenedorFullObjectInformation", { read: ViewContainerRef, static: false }) contenedorFullObjectInformation: ViewContainerRef;
  @ViewChild('gridObjectInformationProgrammer', { static: false }) gridObjectInformationProgrammer: DxDataGridComponent;
  @ViewChild('gridObjectInformationComponents', { static: false }) gridObjectInformationComponents: DxDataGridComponent;
  @ViewChild('gridObjectInformationMobile', { static: false }) gridObjectInformationMobile: DxDataGridComponent;
  @ViewChild("refGridObjectInformation", { static: false }) refGridObjectInformation: TemplateRef<any>;
  @ViewChild("gridObjectInformation", { static: false }) gridObjectInformation: DxDataGridComponent;
  @ViewChild('editMultipleSystems', { static: false }) editMultipleSystems: DxDataGridComponent;
  @ViewChild('treeViewAreaSystem', { static: false }) treeViewAreaSystem: DxTreeViewComponent;
  @ViewChild('treeViewSystemArea', { static: false }) treeViewSystemArea: DxTreeViewComponent;
  @ViewChild("ioconfiguration", { static: false }) ioconfiguration: IoConfigurationComponent;
  @ViewChild('treeViewComponent', { static: false }) treeViewComponent: DxTreeViewComponent;
  @ViewChild("searchEstimate", { static: false }) searchEstimate: DxSelectBoxComponent;
  @ViewChild("newPartSelect", { static: false }) newPartSelect: DxSelectBoxComponent;
  @ViewChild(DxDiagramComponent, { static: false }) diagram: DxDiagramComponent;
  @ViewChild("appNotes", { static: false }) appNotes: DxSelectBoxComponent;




  @ViewChild(DxTreeViewComponent, { static: false }) treeView2;
  // @ViewChild(DxTreeViewComponent, { static: false }) treeView;


  @ViewChild('treeviewType', { static: false }) treeviewType: DxTreeViewComponent;
  @ViewChild('treeviewTag', { static: false }) treeviewTag: DxTreeViewComponent;



  @ViewChild('treeBoxType', { static: false }) treeBoxType: DxDropDownBoxComponent;
  @ViewChild('treeBoxTags', { static: false }) treeBoxTags: DxDropDownBoxComponent;


  introJS = introJs();





  @Input() offsetHeight;
  @Input() title = "";
  // diagram
  // @ViewChild(DxDiagramComponent, { static: false }) diagram: DxDiagramComponent;
  @Input() estimateid = '';
  @Input() estimatenamestr = '';
  @Input() projectid = '';
  @Input() imgSelected = '';
  @Input() FirstGrid: any;
  @Input() modal: any;
  @Input() systemid: any;
  @Output() hidden = new EventEmitter();
  @Output() returnToDiagram = new EventEmitter();
  @Input() _systemid: any;
  @Input() VieneDe: any;
  @Input() componetsIDS: any;
  @Input() dataSystemSelected: any;
  @Input() dontShowModalConfirm: any;

  estimatename = '';
  estimates = [];
  areaSystemComponents = [];
  areaSystemComponentsCopy = [];
  systemComponentDetails = [];
  groupItems = [];
  areaDynamic: any[] = []
  areasCopy: any[] = []
  groupItems2: any[] = []
  expanded = true;
  primeraVez: boolean = true
  slideshowDelay = 2000;
  allInfoPictures: any[] = []
  CopyallInfoPictures: any[] = []



  defaultVisible = false;
  cancelButtonEditPartAndLabor: { text: string; elementAttr: { id: string; }; onClick: () => void; };
  saveButtonEditPartAndLabor: { text: string; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  objectReferenceSelected: any;
  prefixAll: any;
  rowSelected: any[];
  popupMultipleItems: boolean;
  cancelButtonDeletePartAndLabor: { text: string; elementAttr: { id: string; }; onClick: () => void; };
  objectReferenceSelect: any;
  saveButtonDeletePartAndLabor: { text: string; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  cancelButtonNewPart: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  saveButtonNewPart: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  drawingTemplates: any[] = [];
  cancelButtonEditAreaSystem: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  saveButtonEditAreaSystem: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };


  // @Input('systemid')
  // set systemid(systemid: any) {
  //   if (systemid != undefined){
  //     this._systemid = systemid;
  //     this.ngOnInit();
  //   }
  // }

  // get systemid(): any { return this._systemid; }



  currentComponentId = 0;
  popupViewInfoComponent = false;

  popupNewComponent = false;
  components: any[] = [];
  componentsGroups: any[] = [];

  listImg = [
    '7.svg',
    '8.svg',
    '10.svg',
    '10-01.svg',
    '11.svg',
    '12.svg',
    '15.svg',
    '17.svg',
    '23.svg',
    '25.svg',
    '26.svg',
    '29.svg',
    '31.svg',
    '51.svg',
    '53.svg',
    '57.svg',
    '65.svg',
    '69.svg',
    '86.svg',
  ];

  templateJSON = { "page": { "width": 24491, "height": 15817, "pageColor": -1, "pageWidth": 15817, "pageHeight": 24491, "pageLandscape": true, "viewUnits": "in", "units": "in" }, "connectors": [], "shapes": [] };
  componentsGroupsOriginal: any[];

  viewTypeCard: any = 1;

  partDataSource: any;
  partselected: any;
  globalPrefix = null;
  pointTypeGlobal = null;
  commisioningSheet = [];
  popupAssociate: boolean = false
  firstTimeChange: boolean = true
  registryTemporal: any
  nombrecomponente: any = ""
  EnableImage: boolean = false
  component: boolean = false
  componentid: any = 0
  openSystem: boolean = false;
  enableIOALL: boolean = false;
  programInfoDataSource: any;
  programInfoStore: ArrayStore = new ArrayStore({
    data: [],
    key: "DETAILID"
  });
  programInfo = [];
  modalProgrammer: boolean = false
  pointTypeSelect = [];
  customheight = "auto";
  popupEditPartAndLabor = false;
  rowsToEditPartAndLabor = [];
  popupDeletePartAndLabor: boolean = false
  programDetail: any[] = []
  popupFullScreenGridObjectInformation = false;
  popupViewImg: boolean = false
  openModalPartsComponent: boolean = false
  idComponent: any
  DataComponent: any
  value: any[] = [];
  imgbase64: string;
  changeimage: boolean;
  filename: string;
  modelSystemInformation = {
    systemid: "0",
    area: "",
    systemtype: 0,
    systemname: "",
    controldrawing: "",
    controldwimg: "",
    sort: "",
    qty: "",
    active: false,
    SystemBarName: '',
    MarkLib: false,
    SOP: null,
    DESCRIPTION: '',
    TAGNUM: '',
    TAGTEXT: '',
    SystemTypeid: 0,
    id: 0,
  };
  systemComponentDetailsComponents: any[] = []

  SystemUpdated: any[] = []
  ModalConfirmarChangeWidthAndHeight: boolean = false
  contadorFinal: any = 0
  OpenSincro: boolean = false
  SystemComponents: any[] = []
  dontShow: boolean = false
  firtsTime: boolean = true
  popupEditAreaSystem: boolean = false

  // dataSourceFilter = ["By Type", "By Tag"]
  dataSourceFilter = ["By Type"]
  componentSelected: any;
  systemTypeMultipleData: any;

  constructor(
    private systemComponentService: SystemComponentService,
    private MapInformationService: MapInformationService,
    private estimateService: EstimateService,
    private deltaService: DeltaworldService,
    private activatedRouter: ActivatedRoute,
    private utilityService: UtilityService,
    private loadingService: LoadingService,
    private appConfig: AppConfigService,
    private translate: TranslateService,
    private userService: UserService,
    private toast: ToastService,
    private router: Router,
  ) {


    // this.estimatenamestr = activatedRouter.snapshot.queryParamMap.get('project');
    // this.estimateid = activatedRouter.snapshot.queryParamMap.get('estimateid');
    // this.systemid = activatedRouter.snapshot.queryParamMap.get('systemid');




  }

  ngOnInit() {


    this.initForm()

    this.estimateService.Get_EstimateLibComponentsTreeCE2().subscribe(result => {
      this.groupItemsFilter = result

      this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {

        this.typeDatasource = result;


        // get estimate by default 
        this.showEstimateDefault()

        this.getEstimateSelect()

        this.getSystemTypeMultiple()







        this.initImport()

        this.SearchImage()

        setTimeout(() => {
          this.SearchImageFiltered()
        }, 1000);
      });
    });



    this.addEstimateID = {
      icon: "fas fa-cog",
      type: "button",
      onClick: () => {
        let settings: any = localStorage.getItem('settings');
        if (settings && settings != 'null') {
          settings = JSON.parse(settings);
          if (settings.estimateidDefault) {
            this.estimateService.Get_EstimateListNavAll('', settings.estimateidDefault).subscribe(res => {
              if (res.length > 0) {
                let obj = res[0];

                if (!obj)
                  return;

                // this.updateEstimate({ selectedItem: { PROJECT_NAME: obj.PROJECT_NAME, ID: settings.estimateidDefault } });
                setTimeout(() => {
                  this.estimatenameDefault = obj.PROJECT_NAME;
                  this.searchEstimateDefault.placeholder = obj.PROJECT_NAME
                  this.estimateidDefault = obj.ID;
                }, 1000);
              }
              let mythis = this
              this.estimateDataSource = new CustomStore({
                key: "ID",
                load: function (loadOptions: any) {
                  return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
                    .toPromise()
                    .then((data: any) => {
                      return data;
                    })
                    .catch(error => { throw 'Data Loading Error' });
                }
              });
            })
          }
        }
        this.popupDefaultEstimate = true
      }
    };

    this.cancelButtonDefaultEstimate = {
      text: this.translate.instant('ModalSystemType.btnClose'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupDefaultEstimate = false;
        // this.defaultEstimateId = null;
        this.estimatenameDefault = null;
        // this.close();
      },
    };

    this.saveButtonDefaultEstimate = {
      text: this.translate.instant('ModalSystemType.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {

        // if (!this.defaultEstimateId) {
        //   this.toast.warning("Please select default estimate")
        //   return;
        // }

        let settings: any = localStorage.getItem('settings');
        let mythis = this

        if (settings && settings != 'null') {
          settings = JSON.parse(settings);
          settings.estimateidDefault = this.estimateidDefault;
          let userSetting: any = {};
          this.userService.settings.next(settings);
          // userSetting.userid = localStorage.getItem('customerid');
          userSetting.usersettings = JSON.stringify(this.userService.settings.value);
          this.userService.saveUserSettingCoor(userSetting).subscribe(result => {
            this.toast.success(this.translate.instant('msgSavSucc'));
            this.popupDefaultEstimate = false;
            localStorage.setItem('settings', JSON.stringify(settings));
            this.estimateDataSource = []
            this.filter.get("estimateid").setValue(settings.estimateidDefault)
            this.estimateDataSourceFiltro = []
            setTimeout(() => {
              this.estimateDataSourceFiltro = new CustomStore({
                key: "ID",
                load: function (loadOptions: any) {
                  return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
                    .toPromise()
                    .then((data: any) => {
                      return data;
                    })
                    .catch(error => { throw 'Data Loading Error' });
                }
              });
            }, 2000);
            this.estimateService.Get_EstimateListNavAll('', settings.estimateidDefault).subscribe(res => {
              if (res.length > 0) {
                let obj = res[0];

                if (!obj)
                  return;

                this.updateEstimateDefault({ selectedItem: { PROJECT_NAME: obj.PROJECT_NAME, ID: settings.estimateidDefault } });
                this.ngOnInit()
              }
            })
            // this.searchEstimateDefault.placeholder =
            // this.ngOnInit()
          })
        }
        // this.updateNetworkConfiguration();
      },
    };


    if (this.componetsIDS != '') {
      this.categorySelected = this.componetsIDS.split(",").map(x => Number(x))
      this.filter.get("componentType").setValue(this.categorySelected)
    }
  }

  getEstimateSelect() {
    let mythis = this;
    this.estimateDataSourceFiltro = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }


  showEstimateDefault() {
    let settings: any = localStorage.getItem('settings');
    if (settings && settings != 'null') {
      settings = JSON.parse(settings);

      if (settings.estimateidDefault != undefined && settings.estimateidDefault != null && settings.estimateidDefault != '') {
        this.estimateService.Get_EstimateListNavAll('', settings.estimateidDefault).subscribe(res => {
          if (res.length > 0) {
            let obj = res[0];

            if (!obj)
              return;


            this.filter.get("estimateid").setValue(settings.estimateidDefault)

            // this.updateEstimate({ selectedItem: { PROJECT_NAME: obj.PROJECT_NAME, ID: settings.estimateidDefault } });
            this.searchEstimate.placeholder = settings.estimateidDefault + "-" + obj.PROJECT_NAME

            setTimeout(() => {
            }, 1000);
          }
        })

      } else {
        // logica para mostrar algun otro valor en estimate


        this.MapInformationService.SaveInfoSites({
          "method": "Get_EstimateLibraryDefault",
        })
          .subscribe(res => {

            if (res.length > 0) {

              this.filter.get("estimateid").setValue(res[0].id)

              this.searchEstimate.placeholder = res[0].id + "-" + res[0].PROJECT_NAME


              // this.updateEstimate({ selectedItem: { PROJECT_NAME: res[0].PROJECT_NAME, ID: res[0].id } });
            } else {
              this.searchEstimate.placeholder = "Search Estimate..."
            }
          })
      }
    }
  }





  addEstimateID: { icon: string; type: string; onClick: () => void; };
  estimatenameDefault = '';
  estimateidDefault = 0;
  @ViewChild("searchEstimateDefault", { static: false }) searchEstimateDefault: DxSelectBoxComponent;
  filter: FormGroup
  DefaultSystem: FormGroup

  importComponentFromLibrary() {
    this.modal = true

    this.initImport()
    this.cancelButtonDefaultEstimate = {
      text: this.translate.instant('ModalSystemType.btnClose'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupDefaultEstimate = false;
        // this.defaultEstimateId = null;
        this.estimatenameDefault = null;
        // this.close();
      },
    };

    this.saveButtonDefaultEstimate = {
      text: this.translate.instant('ModalSystemType.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {

        // if (!this.defaultEstimateId) {
        //   this.toast.warning("Please select default estimate")
        //   return;
        // }

        let settings: any = localStorage.getItem('settings');
        let mythis = this

        if (settings && settings != 'null') {
          settings = JSON.parse(settings);
          settings.estimateidDefault = this.estimateidDefault;
          let userSetting: any = {};
          this.userService.settings.next(settings);
          // userSetting.userid = localStorage.getItem('customerid');
          userSetting.usersettings = JSON.stringify(this.userService.settings.value);
          this.userService.saveUserSettingCoor(userSetting).subscribe(result => {
            this.toast.success(this.translate.instant('msgSavSucc'));
            this.popupDefaultEstimate = false;
            localStorage.setItem('settings', JSON.stringify(settings));
            this.estimateDataSource = []
            this.filter.get("estimateid").setValue(settings.estimateidDefault)
            this.estimateDataSourceFiltro = []
            setTimeout(() => {
              this.estimateDataSourceFiltro = new CustomStore({
                key: "ID",
                load: function (loadOptions: any) {
                  return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
                    .toPromise()
                    .then((data: any) => {
                      return data;
                    })
                    .catch(error => { throw 'Data Loading Error' });
                }
              });
            }, 2000);
            this.estimateService.Get_EstimateListNavAll('', settings.estimateidDefault).subscribe(res => {
              if (res.length > 0) {
                let obj = res[0];

                if (!obj)
                  return;

                this.updateEstimateDefault({ selectedItem: { PROJECT_NAME: obj.PROJECT_NAME, ID: settings.estimateidDefault } });
              }
            })
            // this.searchEstimateDefault.placeholder =
            // this.ngOnInit()
          })
        }
        // this.updateNetworkConfiguration();
      },
    };

    // this.customScroll()
    // setTimeout(() => {
    //   this.scrollViewstep.instance.release(true)
    // }, 2000);

    this.addEstimateID = {
      icon: "fas fa-cog",
      type: "button",
      onClick: () => {
        let settings: any = localStorage.getItem('settings');
        if (settings && settings != 'null') {
          settings = JSON.parse(settings);
          if (settings.estimateidDefault) {
            this.estimateService.Get_EstimateListNavAll('', settings.estimateidDefault).subscribe(res => {
              if (res.length > 0) {
                let obj = res[0];

                if (!obj)
                  return;

                // this.updateEstimate({ selectedItem: { PROJECT_NAME: obj.PROJECT_NAME, ID: settings.estimateidDefault } });
                setTimeout(() => {
                  this.estimatenameDefault = obj.PROJECT_NAME;
                  this.searchEstimateDefault.placeholder = obj.PROJECT_NAME
                  this.estimateidDefault = obj.ID;
                }, 1000);
              }
              let mythis = this
              this.estimateDataSource = new CustomStore({
                key: "ID",
                load: function (loadOptions: any) {
                  return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
                    .toPromise()
                    .then((data: any) => {
                      return data;
                    })
                    .catch(error => { throw 'Data Loading Error' });
                }
              });
            })
          }
        }
        this.popupDefaultEstimate = true
      }
    };
  }
  popupDefaultEstimate: boolean = false
  cargandoScroll: number = 0
  cancelButtonDefaultEstimate: { text: string; elementAttr: { id: string; }; onClick: () => void; };
  saveButtonDefaultEstimate: { text: string; icon: string; elementAttr: { id: string; }; onClick: () => void; };

  customScroll() {
    var mythis = this;
    $('#myScrollSales').on('scroll', function () {

      if (($(this).scrollTop() + $(this).innerHeight() + 100) >= $(this)[0].scrollHeight && mythis.cargandoScroll == 0) {
      }

    });
  }
  infoPartDetail: any = []
  stimateDataSource: any = []
  projects: any = []
  infoSystemType: any[] = []
  estimateDataSource: any = []
  estimateDataSourceFiltro: any = []

  infoToFilters() {
    let mythis = this

    this.estimateDataSourceFiltro = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    // this.estimateDataSource = new CustomStore({
    //   key: "ID",
    //   load: function (loadOptions: any) {
    //     if (loadOptions.searchValue == "" || loadOptions.searchValue == null) { loadOptions.searchValue = " " } else { loadOptions.searchValue = loadOptions.searchValue }
    //     return mythis.MapInformationService.GetAllInfoDinamicoEstimate("Get_EstimateListNavAll", loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });

    // this.estimateDataSourceFiltro = new CustomStore({
    //   key: "ID",
    //   load: function (loadOptions: any) {
    //     return mythis.MapInformationService.GetAllInfoDinamicoEstimate("Get_EstimateListNavAll", loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });
  }


  taxSelect: any[] = []

  getTaxes() {
    this.estimateService.Get_Taxs().subscribe(result => {
      this.taxSelect = result;
    })
    this.MapInformationService.getParameters('Insert_Estimate')
      .subscribe(resp => {
      })
  }

  updateEstimateDefault(item) {
    if (item.selectedItem) {
      this.filter.get("estimateid").setValue(item.selectedItem.ID)
      if (this.searchEstimate != undefined) {
        this.searchEstimate.placeholder = item.selectedItem.ID + "-" + item.selectedItem.PROJECT_NAME
      }
    }

  }

  getAreaDynamic(estimateid) {
    this.estimateService.GetSystemArea(estimateid).subscribe((result) => {
      this.areaDynamic = result.map(x => {
        x.SystemActive = !x.SystemActive;
        return x;
      });

      this.areasCopy = result;
      this.agrupar3(this.areaDynamic)
    });
  }

  agrupar3(arr) {
    var x = arr.reduce(function (map, node) {
      let parentid = node.ParetID;
      let nodeid = node.ID;
      map.i[nodeid] = node;
      node.items = [];
      if (parentid === null || parentid === 0) {
        map.result.push(node);
      }
      else if (parentid in map.i) {
        map.i[parentid].items.push(node);
      }
      else {
        (parentid in map.cache) ?
          map.cache[parentid].push(node) :
          map.cache[parentid] = [node];
      }
      if (nodeid in map.cache) {
        node.items = node.items.concat(map.cache[nodeid]);
        delete map.cache[nodeid];
      }
      return map;
    }, { i: {}, cache: {}, result: [] }).result;


    let data = x.map(item => {
      let obj = {
        id: Math.random(),
        originalid: (item.ID * -1),
        sort: item.Sort,
        areaname: item.Name,
        areaactive: item.AreaActive,
        icon: item.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
        text: item.Sort + '-' + item.Name,
        expanded: this.expanded,
        infoTotal: item,
        UseCount: item.UseCount,
        items: item.items.map(a => {
          return {
            id: a.ID,
            text: a.Name,
            UseCount: a.UseCount,
            icon: a.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
            issystem: true,
            areaid: (a.ParetID * -1),
            path: a.ImagePath,
            infoTotal: item,
            sistemTypeid: a.SystemTypeID,
            SystemTypeName: a.SystemTypeName,
            TAGNUM: a.TAGNUM,
            TAGTEXT: a.TAGTEXT
          }
        })
      }

      return obj;
    });



    this.groupItems2 = data;

    let first = arr.filter(x => x.ID > 0)[0];

    let child = this.groupItems2.filter(x => x.items.length > 0)[0];
    if (child && child.items.length > 0) {
      // if(this.systemid != undefined){
      //   child.items.forEach(element => {
      //     if(element.id == this.systemid){
      //       this.selectItem({ itemData: element });
      //     }
      //   });
      // } else {
      // this.selectItemTree({ itemData: this.groupItems2[0] });
      // }
    }
    setTimeout(() => {
      this.treeViewSystemArea.instance.collapseAll()
      if (this.PicturesSelected.length > 0) {
        this.PicturesSelected.forEach(element => {
          this.treeViewSystemArea.instance.selectItem(element)
        })
      }
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
      if ($(".dx-treeview-item").length > 1) {
        $(".dx-treeview-item").removeClass("currently-active-item");
        $($(".dx-treeview-item")[0]).addClass("currently-active-item");
      }
    }, 500);
  }

  inicio: any = 0
  until: any = 8
  from: any = 0
  logitudtotal: any = 0
  hideNext: boolean = false
  cantidadRegistro: number = 12
  paginado: number = 1
  openModalFullScreen: boolean = false
  tipoimagen: any
  changeBase64: boolean = true
  imagenFullScreen: any = ""
  PicturesSelected: any[] = []
  firstTimeOne: boolean = true
  firstTimeSecond: boolean = true
  breakScroll: boolean = false
  @ViewChild("scrollViewstep", { static: false }) scrollViewstep: DxScrollViewComponent;
  base64Imagenes: any[] = []
  tempimg = null;



  showImages: boolean = false
  PicturesSelectedWithData: any[] = []
  checkboxmode = 'single';

  selectItem2(e, info) {
    if (info.info.ID == undefined) info.info.ID = info.info.id
    if (e.value != undefined) {
      this.PicturesSelected.push(info.info.ID)
      this.PicturesSelectedWithData.push(info.info)
    } else {
      this.PicturesSelected = this.PicturesSelected.filter(x => x != info.info.ID)
      this.PicturesSelectedWithData = this.PicturesSelectedWithData.filter(x => x.ID != info.info.ID)
    }

    const PicturesSelected = [...new Set(this.PicturesSelected)]

    this.PicturesSelected = PicturesSelected

    var hash = {};
    this.PicturesSelectedWithData = this.PicturesSelectedWithData.filter(function (current) {
      var exists = !hash[current.id];
      hash[current.id] = true;
      return exists;
    });
  }


  selectItem3(e, info) {
    if (info.info.ID == undefined) info.info.ID = info.info.id
    if (e.value != undefined) {
      this.PicturesSelected.push(info.info.ID)
      this.PicturesSelectedWithData.push(info.info)
    } else {
      this.PicturesSelected = this.PicturesSelected.filter(x => x != info.info.ID)
      this.PicturesSelectedWithData = this.PicturesSelectedWithData.filter(x => x.ID != info.info.ID)
    }

    const PicturesSelected = [...new Set(this.PicturesSelected)]

    this.PicturesSelected = PicturesSelected



    var hash = {};
    this.PicturesSelectedWithData = this.PicturesSelectedWithData.filter(function (current) {
      var exists = !hash[current.id];
      hash[current.id] = true;
      return exists;
    });

    this.base64Imagenes.map(x => {
      if (x.info.ID == info.info.ID) {
        x.check = true
      } else {
        x.check = false
      }
      return x;
    })

    this.treeViewSystemArea.instance.selectItem(info.info.ID)
    this.treeViewSystemArea.instance.expandItem(info.info.ID)
  }


  onContentReady2() { }

  onItemExpanded(data) { }

  getSystemRecommended() {
    // this.MapInformationService.SaveInfoSites({method:"Get_EstmateMostUsedSystems"})
    // .subscribe(resp=>{
    //   if(this.SystemRecomended.length == 0){
    //     this.SystemRecomended = resp
    //   }
    //   this.getImagesRecommended(this.SystemRecomended);
    // })
  }
  AccordeonOpenOrClose: any = {
    SystemAreas: true,
    CubeRecommendations: false,
    SystemsSelected: false
  }
  SystemRecomended: any[] = []
  selectedIndex: any = 0
  @ViewChild('listrecomended', { static: false }) listrecomended: DxListComponent;

  getImagesRecommended(data) {
    // this.base64Imagenes = []
    // let infoFinal = []
    // this.allInfoPictures = data
    // this.CopyallInfoPictures = data
    // this.logitudtotal =  this.allInfoPictures.length
    // let contador = 0
    // let hasta = 8

    // this.until = 8
    // this.from = 0
    // this.breakScroll = false
    // this.scrollViewstep.instance.release(true)
    // const dataSelected = this.listrecomended.selectedItems


    // this.filter.get("systemtypeID").setValue("")
    // this.filter.get("tagids").setValue("")

    // if(this.allInfoPictures.length < 8){
    //   hasta = this.allInfoPictures.length
    // }

    // if(this.allInfoPictures.length > 0){
    //   for (let i = 0; i < hasta; i++) {
    //       if(data[i] != undefined){
    //         this.MapInformationService.GetDocumentThumImg(data[i].ImagePath).subscribe(result => {
    //           let tipo
    //           var dataFile = result.filestring.substring(0, 5);
    //           switch(dataFile.toUpperCase()){
    //             case "/9J/4":tipo = "jpeg";
    //             break
    //             default:
    //               tipo = "png"
    //               break
    //           }

    //           // if (dataFile.node != undefined ) {
    //           //   informacion = {
    //           //     tipo:tipo,
    //           //     base64:result.filestring,
    //           //     info:data[i],
    //           //     // check:this.PicturesSelected.includes(data[i].id) ? true : false
    //           //     check:data.node.selected ? true : false
    //           //   }
    //           // } else {
    //             let informacion = {
    //               tipo:tipo,
    //               base64:result.filestring,
    //               info:data[i],
    //               check:dataSelected.includes(data[i].ID) ? true : false
    //               // check:data.node.selected ? true : false
    //             }
    //           // }

    //           // informacion.info.Name = informacion.info.text
    //             this.base64Imagenes.push(informacion)
    //           contador++
    //           if(contador == hasta){
    //             this.from = this.until
    //             this.until = this.until + 8
    //             if(hasta == 8){
    //               this.scrollViewstep.instance.release(false)
    //             } else {
    //               this.scrollViewstep.instance.release(true)
    //             }


    //             if (dataSelected.length > 0) {
    //               dataSelected.forEach(element => {
    //               for (let i = 0; i < this.base64Imagenes.length; i++) {
    //                   if (this.base64Imagenes[i].info.ID == element.ID) {
    //                     this.base64Imagenes[i].check = true
    //                   }
    //                 }
    //               });
    //             } else {
    //               for (let i = 0; i < this.base64Imagenes.length; i++) {
    //                 this.base64Imagenes[i].check = false
    //               }
    //             }


    //             this.showImages = false
    //           }
    //           const infoFinal = {
    //             info: data[i]
    //           }

    //           const infoFinalValue = {
    //             value: data[i].selected
    //           }
    //           // this.selectItem(infoFinalValue, infoFinal)
    //         },error=>{
    //         })
    //       } else {
    //         this.breakScroll = true
    //         this.scrollViewstep.instance.release(true)
    //         // setTimeout(() => {
    //         //   this.scrollViewstep.instance.release(false)
    //         // }, 1000);
    //       }
    //   }
    // }
  }

  DataInfo(e) {
    // switch(e.itemData.title){
    //   case "System Areas":
    //     this.AccordeonOpenOrClose.SystemAreas = !this.AccordeonOpenOrClose.SystemAreas
    //     this.AccordeonOpenOrClose.CubeRecommendations = false
    //     this.AccordeonOpenOrClose.SystemsSelected = false
    //     if (this.AccordeonOpenOrClose.SystemAreas){
    //       // this.SystemRecomended = []
    //       this.base64Imagenes = []
    //       this.initImport()
    //       this.selectedIndex = 0
    //     }
    //     break
    //   case "Cube Recommendations":
    //     this.AccordeonOpenOrClose.CubeRecommendations = !this.AccordeonOpenOrClose.CubeRecommendations
    //     this.AccordeonOpenOrClose.SystemAreas = false
    //     this.AccordeonOpenOrClose.SystemsSelected = false
    //     if (this.AccordeonOpenOrClose.CubeRecommendations){
    //       // this.SystemRecomended = []
    //       this.base64Imagenes = []
    //       this.getSystemRecommended()
    //       this.selectedIndex = 1
    //     }
    //     break
    //   case "Systems Selected":
    //     this.AccordeonOpenOrClose.SystemsSelected = !this.AccordeonOpenOrClose.SystemsSelected
    //     this.AccordeonOpenOrClose.SystemAreas = false
    //     this.AccordeonOpenOrClose.CubeRecommendations = false
    //     this.selectedIndex = 2
    //     break
    // }

  }

  onSelectionChanged(data) {

    // if (data.addedItems.length > 0) {
    //   const infoFinal = {
    //     "id": data.addedItems[0].ID,
    //     "text": data.addedItems[0].Name,
    //     "icon": "",
    //     "issystem": true,
    //     "areaid": data.addedItems[0].ParetID,
    //     "path": data.addedItems[0].ImagePath,
    //     "sistemTypeid": data.addedItems[0].SystemTypeID,
    //     "SystemTypeName": data.addedItems[0].SystemTypeName,
    //     "TAGNUM": data.addedItems[0].TAGNUM,
    //     "TAGTEXT": data.addedItems[0].TAGTEXT,
    //     "Name": data.addedItems[0].Name,
    //     "ID": data.addedItems[0].ID,
    //     "selected": true,
    //     "img": "",
    //   }
    //   this.PicturesSelectedWithData.push(infoFinal)
    //   this.base64Imagenes.forEach(x=>{
    //     if (x.info.ID == data.addedItems[0].ID){
    //       x.check = true
    //     }
    //   })

    // } else if (data.removedItems.length > 0){
    //   const infoFinal = {
    //     "id": data.removedItems[0].ID,
    //     "text": data.removedItems[0].Name,
    //     "icon": "",
    //     "issystem": true,
    //     "areaid": data.removedItems[0].ParetID,
    //     "path": data.removedItems[0].ImagePath,
    //     "sistemTypeid": data.removedItems[0].SystemTypeID,
    //     "SystemTypeName": data.removedItems[0].SystemTypeName,
    //     "TAGNUM": data.removedItems[0].TAGNUM,
    //     "TAGTEXT": data.removedItems[0].TAGTEXT,
    //     "Name": data.removedItems[0].Name,
    //     "ID": data.removedItems[0].ID,
    //     "selected": false,
    //     "img": "",
    //   }
    //   this.DeleteSystem(infoFinal)
    //   this.base64Imagenes.forEach(x=>{
    //   if (x.info.ID == data.removedItems[0].ID){
    //     x.check = false
    //   }
    // })
    // }


  }

  primeravez: boolean = true

  DeleteSystem(info) {

    let infomation = {
      info: info
    }
    let data = {
      value: false
    }


    let keys = this.listrecomended.selectedItemKeys

    this.SystemRecomended.forEach((x, index) => {
      if (info.id == x.SystemId) {
        this.listrecomended.instance.unselectItem(index)
      }
    })



    if (this.primeravez) {
      this.primeraVez = false
      this.selectItem2(data, infomation)
      this.base64Imagenes = this.base64Imagenes.map(element => {

        if (element.info.id == info.id) {
          element.check = false
          this.treeViewSystemArea.instance.unselectItem(info.id)
        }
        return element
      })

    } else {
      this.primeraVez = true
    }
  }

  updateDefaultEstimate(item) {
    if (item.selectedItem) {
      // setTimeout(() => {
      this.estimatenameDefault = item.selectedItem.PROJECT_NAME;
      this.estimateidDefault = item.selectedItem.ID;
      this.searchEstimateDefault.placeholder = item.selectedItem.PROJECT_NAME
      // }, 1000);

      // this.getAreaDynamic(item.selectedItem.ID);
    }
  }

  ReloadTree(item) {
    if (item.selectedItem) {
      this.filter.get("estimateid").setValue(item.selectedItem.ID)
      this.SearchImageFiltered()
    }

  }

  hiddenClose() {
    this.hidden.emit()
  }

  ImportSystem(areaID) {

    const idSystem = this.treeViewSystemArea.instance.getSelectedNodeKeys()

    if (areaID != undefined && areaID < 0) {
      if (idSystem.length > 0) {
        this.estimateService.DuplicateSystemSingle(areaID * -1, idSystem[0]).subscribe(result => {
          this.estimateService.duplicateImage(idSystem[0], result[0].ID)
            .subscribe(res1 => {
              this.toast.success(this.translate.instant('ModuleImportLibrary.msgSucc'));
              this.hidden.emit()
              // this.getSystemArea();
            })
        })
      } else {
        this.toast.warning("You must select a system")
      }
    } else {
      this.toast.warning("You must select an area")
    }
  }


  initImport() {

    let settings = JSON.parse(localStorage.getItem('settings'))
    if (settings != undefined) {
      if (settings.estimateidDefault != undefined) {
        this.filter.get("estimateid").setValue(settings.estimateidDefault)
        // this.filter.get("systemtypeID").setValue(settings.DefaultSystemType)
        // this.filter.get("systemtypeID").setValue([Number(settings.DefaultSystemType)])
        this.estimateService.Get_EstimateListNavAll('', settings.estimateidDefault).subscribe(res => {
          if (res.length > 0) {
            let obj = res[0];

            if (!obj)
              return;

            this.updateEstimateDefault({ selectedItem: { PROJECT_NAME: obj.PROJECT_NAME, ID: settings.estimateidDefault } });
            this.infoToFilters()
            // this.getAreaDynamic(settings.estimateidDefault)
          }
        })
      }
    }

    // if(event.activeStep.name == "System Recommended"){
    // this.getTaxes()
    // this.getSystemRecommended()
    // }

    // this.customScroll()
    // this.getImages()
  }

  initForm() {
    console.log('this.dataSystemSelected', this.dataSystemSelected);
    if (this.componetsIDS == "") {
      this.filter = new FormGroup({
        systemid: new FormControl('', []),
        systemtypeID: new FormControl(this.dataSystemSelected != undefined ? this.dataSystemSelected.systemTypeID : '', []),
        partid: new FormControl('', []),
        verticalmarketid: new FormControl('', []),
        inputappnotes: new FormControl('', []),
        islibrary: new FormControl(true, []),
        projectname: new FormControl('', []),
        systemname: new FormControl('', []),
        projectbidstatusid: new FormControl('', []),
        outputappnotes: new FormControl('', []),
        tagids: new FormControl('', []),
        designerids: new FormControl('', []),
        estimateid: new FormControl('', []),
        componentType: new FormControl('', []),
      })

      this.typeids = this.dataSystemSelected != undefined ? this.dataSystemSelected.systemTypeID : ''


    } else {
      this.filter = new FormGroup({
        systemid: new FormControl('', []),
        systemtypeID: new FormControl(this.dataSystemSelected != undefined ? this.dataSystemSelected.systemTypeID : '', []),
        partid: new FormControl('', []),
        verticalmarketid: new FormControl('', []),
        inputappnotes: new FormControl('', []),
        islibrary: new FormControl(true, []),
        projectname: new FormControl('', []),
        systemname: new FormControl('', []),
        projectbidstatusid: new FormControl('', []),
        outputappnotes: new FormControl('', []),
        tagids: new FormControl('', []),
        designerids: new FormControl('', []),
        estimateid: new FormControl('', []),
        componentType: new FormControl(this.componetsIDS.split(","), []),
      })
      this.typeids = this.dataSystemSelected != undefined ? this.dataSystemSelected.systemTypeID : ''
    }


    console.log('this.filter', this.filter.value);


    this.DefaultSystem = new FormGroup({
      systemtypeID: new FormControl([], [Validators.required]),
    });

  }

  groupItemsFilter: any[] = []
  typeDatasource: any[] = []
  openFilterParents() {
    let otherArray = []

    this.estimateService.Get_EstimateLibComponentsTreeCE2().subscribe(result => {
      this.groupItemsFilter = result
    });

    this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      this.typeDatasource = result;
    });
  }

  treeBoxValue: string[] = [];

  syncTreeViewSelection(e) {
    var component =
      (e && e.component) || (this.treeviewType && this.treeviewType.instance);

    if (!component) return;

    if (!this.treeBoxValue) {
      component.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }

  }

  categorySelected: any[] = []

  treeView_itemSelectionChanged(e) {
    if (e.itemElement != undefined) {

      this.treeBoxValue = e.component.getSelectedNodeKeys();


      this.categorySelected = e.itemData.ID
      this.filter.get("componentType").setValue(this.treeBoxValue)

      this.SearchImageFiltered()

    }
  }


  typeids: any[] = []
  syncTreeViewSelection2(e) {

    var component =
      (e && e.component) || (this.treeviewTag && this.treeviewTag.instance);

    if (!component) return;

    if (!this.treeBoxValue2) {
      component.unselectAll();
    }

    if (this.treeBoxValue2) {
      this.treeBoxValue2.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }
  }

  treeBoxValue2: string[] = [];
  notAllowed: boolean = false
  FirtsTime: boolean = true

  treeView_itemSelectionChanged2(e) {
    if (e.itemElement != undefined) {
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
      this.typeids = e.itemData.ID
      this.filter.get("systemtypeID").setValue(this.treeBoxValue2)
      this.SearchImageFiltered()
    }
  }

  imagesFiltered: any[] = []
  infoTree: any[] = []
  imagesFilteredCopy: any[] = []

  SearchImage() {
    let infoFilter = this.filter.value
    this.imagesFiltered = []


    let idComponentsFinal = []
    if (infoFilter.componentType.length > 0) {
      infoFilter.componentType.forEach(element => {
        this.groupItemsFilter.forEach(x => {
          if (element == x.ID) {
            if (x.TreeFlag == "C") {
              idComponentsFinal.push(element)
            }
          }
        })
      });
    }




    this.deltaService.GetEstimateSystemTypeCE().subscribe((dataType) => {

      console.log('infoFilter', infoFilter);



      let data = {
        method: "Get_AreaSystemAllCE2NyComponentsIds", //Get_AreaSystemAllCE2NyComponentsIds    || Get_AreaSystemAllCE2
        systemids: infoFilter.systemid,
        systemtypeids: infoFilter.systemtypeID != "" ? infoFilter.systemtypeID : "",
        componentids: idComponentsFinal.join(","),
        estimateid: infoFilter.estimateid,
        islibrary: infoFilter.islibrary == "Yes" ? 1 : infoFilter.islibrary
      }


      this.MapInformationService.SaveInfoSites(data).subscribe((result) => {




        if (dataType.length > 1) {
          // this.treeViewSystemArea.instance.selectItem(result[0].ID)


          let imagesWithPath = result.filter(x => x.ID > 0)
          imagesWithPath.sort(this.compareNames)

          this.infoTree = result
          console.log('this.infoTree', this.infoTree);


          if (result.length > 0) {
            setTimeout(() => {
              this.treeViewSystemArea.instance.selectItem(result[0].ID)
              infoFilter.systemtypeID = [result[0].ID]
            }, 500);

            if (imagesWithPath.length > 0) {
              let dataToSave = []
              let contador = 0

              imagesWithPath.forEach(x => {

                this.imagesFilteredCopy.push(x)

                // const dataTempo = this.imagesFilteredCopy.filter(x => x.ParetID == item.itemData.ID)

                if (x.SystemTypeID == dataType[1].ID) {
                  this.MapInformationService.GetDocumentThumImg(x.ImagePath).subscribe(resultImages => {
                    contador++
                    const data = resultImages.filestring.substring(0, 5);
                    let tipo = ""
                    switch (data.toUpperCase()) {
                      case "/9J/4": tipo = "jpeg";
                        break
                      default:
                        tipo = "png"
                        break
                    }
                    x.base64 = resultImages.filestring
                    x.tipo = tipo
                    x.check = false
                    // this.imagesFiltered.push(x)
                    dataToSave.push(x)

                    if (contador == imagesWithPath.length) {
                      // Remove duplicates based on ImagePath
                      const uniqueItems = dataToSave.filter((item, index, array) =>
                        array.findIndex(t => t.ImagePath === item.ImagePath) === index
                      );

                      // Sort by UseCount descending (most used first)
                      this.imagesFiltered = uniqueItems.sort((a, b) => (b.UseCount || 0) - (a.UseCount || 0))
                    }

                  })

                } else {
                  contador++
                  x.base64 = ''
                  x.tipo = ''
                  x.check = false

                  // this.imagesFiltered.push(x)
                  // this.imagesFilteredCopy.push(x)
                }
              })
            }

            this.agrupar3(this.areaDynamic)
          }

        }


      });
    });


  }
  


  SearchImageFiltered() {
    let infoFilter = this.filter.value
    this.imagesFiltered = []


    let idComponentsFinal = []
    if (infoFilter.componentType.length > 0) {
      infoFilter.componentType.forEach(element => {
        this.groupItemsFilter.forEach(x => {
          if (element == x.ID) {
            if (x.TreeFlag == "C") {
              idComponentsFinal.push(element)
            }
          }
        })
      });
    }




    this.deltaService.GetEstimateSystemTypeCE().subscribe((dataType) => {


      console.log('infoFilter', infoFilter);


      let data = {
        method: "Get_AreaSystemAllCE2NyComponentsIds", //Get_AreaSystemAllCE2NyComponentsIds    || Get_AreaSystemAllCE2
        systemids: infoFilter.systemid,
        systemtypeids: infoFilter.systemtypeID != "" ? infoFilter.systemtypeID : "",
        componentids: idComponentsFinal.join(","),
        estimateid: infoFilter.estimateid,
        islibrary: infoFilter.islibrary == "Yes" ? 1 : infoFilter.islibrary
      }


      this.MapInformationService.SaveInfoSites(data).subscribe((result) => {



        let imagesWithPath = result.filter(x => x.ID > 0)

        imagesWithPath.sort(this.compareNames)


        this.infoTree = result
        console.log('this.infoTree', this.infoTree);

        if (result.length > 0) {
          setTimeout(() => {
            this.treeViewSystemArea.instance.selectItem(result[0].ID)
          }, 1000);
        }

        let dataToSave = []


        if (imagesWithPath.length > 0) {
          let contador = 0



          imagesWithPath.forEach(x => {

            this.imagesFilteredCopy.push(x)

            // const dataTempo = this.imagesFilteredCopy.filter(x => x.ParetID == item.itemData.ID)

            if (x.ParetID == result[0].ID) {


              this.MapInformationService.GetDocumentThumImg(x.ImagePath).subscribe(resultImages => {
                contador++
                const data = resultImages.filestring.substring(0, 5);
                let tipo = ""
                switch (data.toUpperCase()) {
                  case "/9J/4": tipo = "jpeg";
                    break
                  default:
                    tipo = "png"
                    break
                }
                x.base64 = resultImages.filestring
                x.tipo = tipo
                x.check = false
                // this.imagesFiltered.push(x)
                dataToSave.push(x)

                if (contador == imagesWithPath.length) {
                  // Remove duplicates based on ImagePath
                  const uniqueItems = dataToSave.filter((item, index, array) =>
                    array.findIndex(t => t.ImagePath === item.ImagePath) === index
                  );

                  // Sort by UseCount descending (most used first)
                  this.imagesFiltered = uniqueItems.sort((a, b) => (b.UseCount || 0) - (a.UseCount || 0))
                }

              })

            } else {
              contador++
              x.base64 = ''
              x.tipo = ''
              x.check = false

              // this.imagesFiltered.push(x)
              // this.imagesFilteredCopy.push(x)
            }
          })
        }

        this.agrupar3(this.areaDynamic)
      });
    });


  }

  compareNames(a, b) {
    const nameA = a.Name.toUpperCase();
    const nameB = b.Name.toUpperCase();

    // Divide los nombres en partes alfabéticas y numéricas
    const partsA = nameA.match(/([^\d]+|\d+)/g);
    const partsB = nameB.match(/([^\d]+|\d+)/g);

    // Compara las partes secuencialmente
    for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
      const partA = partsA[i];
      const partB = partsB[i];

      if (isNaN(partA) && isNaN(partB)) {
        // Ambas partes son alfabéticas, compara como cadenas
        if (partA < partB) return -1;
        if (partA > partB) return 1;
      } else {
        // Al menos una parte es numérica, convierte a número y compara
        const numA = parseInt(partA) || 0;
        const numB = parseInt(partB) || 0;

        if (numA < numB) return -1;
        if (numA > numB) return 1;
      }
    }

    // Si los nombres son idénticos hasta este punto, compara por longitud
    return partsA.length - partsB.length;
  }

  clearFilter() {
    this.initForm()
    this.typeids = []
    this.categorySelected = []
    this.treeBoxValue = []
    this.treeBoxValue2 = []
    if (this.treeBoxTags != undefined) {
      this.treeBoxTags.instance.reset()
    }

    if (this.treeviewTag != undefined) {
      this.treeviewTag.instance.unselectAll()
    }

    if (this.treeBoxType != undefined) {
      this.treeBoxType.instance.reset()
    }

    if (this.treeviewType != undefined) {
      this.treeviewType.instance.unselectAll()
    }
    this.searchEstimate.instance.reset()
    this.infoToFilters()
    this.initImport()
  }


  selectsystemFromCard(e, info) {
    if (e.event != undefined) {

      this.imagesFiltered.map(x => {
        if (x.ID == info.ID) {
          x.check = e.value
          x.selected = e.value
          if (e.value) {
            this.treeViewSystemArea.instance.selectItem(info.ID)
          } else {
            this.treeViewSystemArea.instance.unselectItem(x.ID)
          }
        } else {
          x.check = false
          x.selected = false
          this.treeViewSystemArea.instance.unselectItem(x.ID)
        }
        return x
      })

    }

  }

  itemIndex = 0

  selectItemTree(item) {


    if (this.itemIndex != item.itemIndex) {
      if (item.itemElement != undefined) {
        if (item.itemData.ID > 0) {
          this.imagesFiltered.map(x => {
            if (x.ID == item.itemData.ID) {
              x.check = !x.check
              x.selected = !x.selected
            } else {
              x.check = false
              x.selected = false
            }
            return x
          })
        } else {

          const dataTempo = this.imagesFilteredCopy.filter(x => x.ParetID == item.itemData.ID)

          let contador = 0
          dataTempo.forEach(x => {
            this.MapInformationService.GetDocumentThumImg(x.ImagePath).subscribe(resultImages => {
              contador++
              const data = resultImages.filestring.substring(0, 5);
              let tipo = ""
              switch (data.toUpperCase()) {
                case "/9J/4": tipo = "jpeg";
                  break
                default:
                  tipo = "png"
                  break
              }
              x.base64 = resultImages.filestring
              x.tipo = tipo
              x.check = false
              if (contador == dataTempo.length) {
                // Remove duplicates based on ImagePath
                const uniqueItems = dataTempo.filter((item, index, array) =>
                  array.findIndex(t => t.ImagePath === item.ImagePath) === index
                );
                // Sort by UseCount descending (most used first)
                this.imagesFiltered = uniqueItems.sort((a, b) => (b.UseCount || 0) - (a.UseCount || 0))
              }
            })
          })



        }
      }
    }
    this.itemIndex = item.itemIndex


  }

  selectItem(item) {

    // this.itemSelected = item


    if (item.itemElement != undefined) {
      if (item.itemData.ID < 0) {

        const dataTempo = this.imagesFilteredCopy.filter(x => x.ParetID == item.itemData.ID)

        // Remove duplicates based on ImagePath
        const uniqueItems = dataTempo.filter((item, index, array) =>
          array.findIndex(t => t.ImagePath === item.ImagePath) === index
        );
        // Sort by UseCount descending (most used first)
        this.imagesFiltered = uniqueItems.sort((a, b) => (b.UseCount || 0) - (a.UseCount || 0))


        // const dataTempo = this.imagesFilteredCopy.filter(x => x.ParetID == item.itemData.ID)

        let contador = 0
        dataTempo.forEach(x => {
          this.MapInformationService.GetDocumentThumImg(x.ImagePath).subscribe(resultImages => {
            contador++
            const data = resultImages.filestring.substring(0, 5);
            let tipo = ""
            switch (data.toUpperCase()) {
              case "/9J/4": tipo = "jpeg";
                break
              default:
                tipo = "png"
                break
            }
            x.base64 = resultImages.filestring
            x.tipo = tipo
            x.check = false
            if (contador == dataTempo.length) {
              // Remove duplicates based on ImagePath
              const uniqueItems = dataTempo.filter((item, index, array) =>
                array.findIndex(t => t.ImagePath === item.ImagePath) === index
              );
              // Sort by UseCount descending (most used first)
              this.imagesFiltered = uniqueItems.sort((a, b) => (b.UseCount || 0) - (a.UseCount || 0))
            }
          })
        })

      } else {


      }
    }




    // $(".dx-treeview-item").removeClass("currently-active-item");
    // $(item.itemElement).addClass("currently-active-item");
  }


  onContentReadytree(e) {

    if (this.componetsIDS != "") {
      this.componetsIDS.split(",").forEach(x => {
        this.treeviewType.instance.selectItem(Number(x))
      })
    }



  }

  openPopupImport: boolean = false

  ImportSystemDiagram() {

    console.log(this.dataSystemSelected)

    if (this.dataSystemSelected.fromDiagram) {
      const idSystem = this.treeViewSystemArea.instance.getSelectedNodeKeys()
      this.dataSystemSelected.systemOrigin = idSystem[0]
      this.returnToDiagram.emit(this.dataSystemSelected)
      
      this.modal = false
    } else {
      if (this.dontShowModalConfirm) {
        this.deleteComponentAndImport()
      } else {
        this.openPopupImport = true
      }
    }


  }

  deleteComponentAndImport() {
    this.estimateService.Insert_EstimateRevisionAreaSystemDetailCE2_SCV2(this.systemid, "").subscribe(result => {
      this.importComponents()
    });
  }

  importComponents() {
    const idSystem = this.treeViewSystemArea.instance.getSelectedNodeKeys()

    if (this.VieneDe == "Diagrama") {
      if (idSystem.length > 0) {
        this.MapInformationService.SaveInfoSites({
          "method": "ImportintoSystemSingle",
          "systemid": idSystem[0],
          "newsystemid": this.systemid
        })
          .subscribe(res1 => {
            this.toast.success(this.translate.instant('ModuleImportLibrary.msgSucc'));
            this.hidden.emit()
            // this.getSystemArea();
          })
      } else {
        this.toast.warning("You must select a system")
      }
    } else {
      console.log("idSystem", idSystem)
      this.dataSystemSelected.sytemOrigin = idSystem[0]
      this.hidden.emit(this.dataSystemSelected)
    }
  }


  clearFilterIndividual(typeOfClear) {
    switch (typeOfClear) {
      case 'System Type':
        this.typeids = []
        this.treeBoxValue2 = []
        if (this.treeBoxTags != undefined) {
          this.treeBoxTags.instance.reset()
        }

        if (this.treeviewTag != undefined) {
          this.treeviewTag.instance.unselectAll()
        }

        this.filter.get("systemtypeID").setValue("")

        break
      case 'Component Type':

        this.categorySelected = []
        this.treeBoxValue = []

        if (this.treeBoxType != undefined) {
          this.treeBoxType.instance.reset()
        }

        if (this.treeviewType != undefined) {
          this.treeviewType.instance.unselectAll()
        }
        this.filter.get("componentType").setValue("")
        this.SearchImageFiltered()
        break
      case 'Estimate ID':
        this.searchEstimate.instance.reset()
        this.filter.get("estimateid").setValue("")
        this.searchEstimate.placeholder = ""

        let settings: any = localStorage.getItem('settings');

        if (settings && settings != 'null') {
          settings = JSON.parse(settings);
          // settings.estimateidDefault = '';
          delete settings.estimateidDefault;
          let userSetting: any = {};
          this.userService.settings.next(settings);
          userSetting.usersettings = JSON.stringify(this.userService.settings.value);
          this.userService.saveUserSettingCoor(userSetting).subscribe(result => {
            this.toast.success(this.translate.instant('ModuleImportLibrary.msgSavSucc'));
            this.popupDefaultEstimate = false;
            localStorage.setItem('settings', JSON.stringify(settings));
            this.estimateDataSource = []
            // this.isFirstTime = true
            this.base64Imagenes = []
            this.searchEstimate.placeholder = "Search Estimate..."
            this.areaDynamic = []

            this.ngOnInit()
          })
        }

        break
    }
  }

  closeParentsSystemType() {
    this.treeviewTag.instance.collapseAll()
  }

  OpenParentsSystemType() {
    this.treeviewTag.instance.expandAll()
  }


  closeParentsComponentType() {
    this.treeviewType.instance.collapseAll()
  }

  OpenParentsComponentType() {
    this.treeviewType.instance.expandAll()
  }

  closeParentsAreasSystems() {
    this.treeViewSystemArea.instance.collapseAll()
  }

  OpenParentsAreasSystems() {
    this.treeViewSystemArea.instance.expandAll()
  }

  goToCubeShop() {


    let url = window.location.href.split("#");
    let finalUrl = `${url[0]}#/applications`;
    window.open(finalUrl, "_blank");
  }


  getSystemTypeMultiple() {
    this.MapInformationService.SaveInfoSites({ method: "Get_EstimateSytemTypeCreateSystem" })
      .subscribe(resp => {
        this.systemTypeMultipleData = resp
      })

  }

  onSelectBoxChanged(e) {
    console.log('e', e);
    if (e.event != undefined) {
      this.filter.get("systemtypeID").setValue(e.value)
      this.dataSystemSelected.systemTypeID = e.value
      this.typeids = e.value
      this.SearchImageFiltered()
    }
  }

  clearFilterNew() {
    this.filter.get("systemtypeID").setValue("")
    this.typeids = []
    this.SearchImageFiltered()
  }









}